import { Helmet } from 'react-helmet-async';

import './about-us.style.css';
import FooterNew from '../../../components/Footer/section-footer';

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title> About Us | Who We Are | Ahguide </title>
        <meta
          name="description"
          content="A H GUIDE is a Coaching Institute fully dedicated to West Bengal Civil Service only. It has sole responsibility for all the aspirants admitted here to prepare properly themselves."
        />
        <link rel="canonical" href="https://www.ahguide.in/about-us" />
      </Helmet>
      <div className="section">
        <div className="container">
          <h2 className="heading-secondary margin-bottom-m">About Us</h2>
          <p className="header-description">
            A H GUIDE is a Coaching Institute fully dedicated to West Bengal
            Civil Service only. It has sole responsibility for all the aspirants
            admitted here to prepare properly themselves.
            <br />
            <br />
            It has some unique features which include some new techniques,
            concepts etc and provide effective and to the point study materials.
            Many disciplines and self-duties are to be followed by the students
            for overall development of their preparation.
          </p>
        </div>
      </div>
      <FooterNew />
    </>
  );
};

export default AboutUs;
